module.exports = __webpack_public_path__ + "img/banner-layer2.fa78c22a.png";